var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualifyLeads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.681,
    y: 0.681,
    width: 30.639,
    height: 30.639,
    rx: 6.565,
    fill: "url(#qualify_leads_svg__paint0_linear_110_4456)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6.273A9.727 9.727 0 116.273 16c0-5.372 4.355-9.727 9.727-9.727zm-2.61 5.306l-.202.004c-1.693.09-2.994 1.553-2.906 3.27a5.52 5.52 0 001.162 3.776c.095.254.098.535.008.791-.864.325-1.57.613-2.134.904A7.951 7.951 0 0016 23.958a7.936 7.936 0 003.14-.643c.136-.255.182-.56.107-.862a3.765 3.765 0 00-.224-.695c-.465-.95-1.638-1.53-3.762-2.324a1.114 1.114 0 01-.027-.779 5.544 5.544 0 001.18-3.802 3.187 3.187 0 000-.324c-.086-1.648-1.42-2.93-3.024-2.95zm6.636.884l-.195.004c-.962.05-1.788.58-2.263 1.348.042.211.07.428.081.65l.005.113.001.113-.005.159.011.2c.019.77-.093 1.531-.33 2.253.182.615.48 1.195.88 1.707.048.125.07.258.068.39.796.443 1.311.899 1.674 1.485l.116.2.069.134c.114.236.213.538.308.924l.091.404a8.203 8.203 0 002.024-2.04l.227-.347c-.314-.13-.657-.263-1.032-.403a1.035 1.035 0 01-.025-.723 5.148 5.148 0 001.095-3.53c.005-.101.005-.202 0-.302-.079-1.527-1.314-2.715-2.8-2.739z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "qualify_leads_svg__paint0_linear_110_4456",
    x1: 0.681,
    y1: 0.681,
    x2: 0.681,
    y2: 31.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualifyLeads);
export default ForwardRef;